export const themeKeys = { DARK: "dark", LIGHT: "light" };

export const themes = {
  light: {
    bgContrast: "#262837",
    menubg: "#C2C2C2C6",
    drawerbg: "#FFFFFF",
    volumeSlider: { bg: "#262837", fill: "#f0f0f0" },
    primaryText: "black",
    primaryBackground: "#f0f0f0",
    secondaryBackground: "#FFFFFF",
    terciaryBackground: "rgba(216,236,235,0.8)",
    ambientLight: { intensity: 2.0, color: "#FFFEF9" },
    pointLight: { intensity: 3.0, color: "#FFFFFF" },
    lampLight: { color: "#FFFEF5", intensity: 25 },
  },
  dark: {
    bgContrast: "#00caff",
    menubg: "#878787D3",
    drawerbg: "#222222",
    volumeSlider: { bg: "#00caff", fill: "#f0f0f0" },
    primaryText: "white",
    primaryBackground: "#262837",
    secondaryBackground: "#424242",
    terciaryBackground: "rgba(216,236,235,0.6)",
    ambientLight: { intensity: 1.5, color: "#F2F7FF" },
    pointLight: { intensity: 3.0, color: "#FFFFFF" },
    lampLight: { color: "#FFFDEE", intensity: 60 },
  },
};
